// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/logger/logs.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_LOGS = [
  {
    id: 'id',
    label: 'ID',
    width: 90,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Petición',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'requestDate',
    label: 'Fecha de la petición',
    width: 160,
    sortable: true,
    filter: 'date',
    group: 'Petición',
    hora: true,
  },
  {
    id: 'userEmail',
    label: 'Usuario',
    width: 240,
    sortable: true,
    filter: 'multi',
    group: 'Petición',
  },
  { id: 'action', label: 'Acción', width: 220, sortable: true, filter: 'multi', group: 'Petición' },
  {
    id: 'requestParams',
    label: 'Parámetros',
    width: 260,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Petición',
  },
  {
    id: 'remoteAddress',
    label: 'IP',
    width: 130,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Petición',
  },
  { id: 'website', label: 'Web', width: 220, sortable: true, filter: 'multi', group: 'Petición' },
  {
    id: 'logEmpresaId',
    label: 'ID empresa',
    width: 110,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Petición',
  },
  {
    id: 'clientId',
    label: 'ID cliente',
    width: 110,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Petición',
  },
  {
    id: 'responseCode',
    label: 'Código de respuesta',
    width: 150,
    sortable: true,
    filter: 'multi',
    group: 'Respuesta',
  },
  {
    id: 'responseStatus',
    label: 'Estado de respuesta',
    width: 160,
    sortable: true,
    filter: 'multi',
    group: 'Respuesta',
  },
  {
    id: 'responseDate',
    label: 'Fecha de la respuesta',
    width: 160,
    sortable: true,
    filter: 'date',
    defaultVisible: false,
    group: 'Respuesta',
    hora: true,
  },
  {
    id: 'elapsedTime',
    label: 'Tiempo',
    width: 100,
    sortable: true,
    filter: 'text',
    group: 'Respuesta',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_LOGS = 'logs';
